export default __webpack_public_path__ + "static/media/panel-effects.238d2a9b.svg";